module.exports = __webpack_public_path__ + "media/bootstrap-icons/patch-question-fill-f0b845d0.svg";